// src/pages/Login.jsx
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  signInWithEmailAndPassword,
  signInWithPopup,
  sendPasswordResetEmail
} from "firebase/auth";
import { auth, googleProvider } from "../firebaseConfig";
import "./Auth.css";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();

  // read redirect param
  const params = new URLSearchParams(location.search);
  const redirect = params.get("redirect") || "/";

  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [resetEmail, setResetEmail] = useState("");
  const [resetSent, setResetSent] = useState(false);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // -----------------------------
  // Login with Email + Password
  // -----------------------------
  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    if (!form.email.trim()) return setErrorMsg("Enter your email.");
    if (!form.password.trim()) return setErrorMsg("Enter password.");

    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, form.email, form.password);

      navigate(redirect, { replace: true });
    } catch (err) {
      setErrorMsg(err.message.replace("Firebase:", "").trim());
    }
    setLoading(false);
  };

  // -----------------------------
  // Google Login
  // -----------------------------
  const handleGoogle = async () => {
    setLoading(true);
    setErrorMsg("");
    try {
      await signInWithPopup(auth, googleProvider);
      navigate(redirect, { replace: true });
    } catch (err) {
      setErrorMsg(err.message.replace("Firebase:", "").trim());
    }
    setLoading(false);
  };

  // -----------------------------
  // Reset Password
  // -----------------------------
  const handleSendReset = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    if (!resetEmail.trim())
      return setErrorMsg("Enter the email to send reset link.");

    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, resetEmail);
      setResetSent(true);
    } catch (err) {
      setErrorMsg(err.message.replace("Firebase:", "").trim());
    }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-card">

        <h2>Welcome Back 👋</h2>
        <p style={{ marginBottom: 10, color: "#666" }}>
          Sign in to continue shopping.
        </p>

        {/* ERROR MESSAGE */}
        {errorMsg && (
          <div className="auth-error">
            {errorMsg}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <label>Email Address</label>
          <input
            type="email"
            name="email"
            value={form.email}
            placeholder="you@example.com"
            onChange={handleChange}
          />

          <label>Password</label>
          <input
            type="password"
            name="password"
            value={form.password}
            placeholder="********"
            onChange={handleChange}
          />

          <button className="auth-btn" type="submit" disabled={loading}>
            {loading ? "Please wait..." : "Login"}
          </button>
        </form>

        {/* Google Button */}
        <button
          className="auth-btn google-btn"
          onClick={handleGoogle}
          disabled={loading}
        >
          {loading ? "Processing..." : "Continue with Google"}
        </button>

        {/* Forget Password */}
        <button
          className="link-btn"
          onClick={() =>
            document.getElementById("resetBox").scrollIntoView({
              behavior: "smooth"
            })
          }
        >
          Forgot password?
        </button>

        {/* RESET BOX */}
        <div id="resetBox" className="reset-box">
          <form onSubmit={handleSendReset}>
            <input
              type="email"
              placeholder="Enter email to reset"
              value={resetEmail}
              onChange={(e) => {
                setResetEmail(e.target.value);
                setResetSent(false);
              }}
            />
            <button disabled={loading}>Send Reset Link</button>
          </form>

          {resetSent && (
            <p style={{ color: "green", marginTop: 6 }}>
              Reset link sent ✓ Check your inbox
            </p>
          )}
        </div>

        {/* Signup link */}
        <p className="auth-switch">
          Don’t have an account? <a href="/signup">Signup</a>
        </p>
      </div>
    </div>
  );
}
